// i18n.ts
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import omLocal from "../locales/om/translation_om.json";
import enLocal from "../locales/en/translation_en.json";
import soLocal from "../locales/so/translation_so.json";
import amLocal from "../locales/am/translation_am.json";
import { LANGUAGES } from '../constants/constants';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem("i18nextLng") || LANGUAGES.AMHARIC.value,
    resources: {
      en: {
        translation: enLocal,
      },
      om: {
        translation: omLocal,
      },
      so: {
        translation: soLocal,
      },
      am: {
        translation: amLocal,
      },
    },
    fallbackLng: localStorage.getItem("i18nextLng") || LANGUAGES.AMHARIC.value,
    debug: true,
    interpolation: {
      escapeValue: false,
    },

  });

  const handleLanguageChange = (newLanguage: any) => {
    console.log(`languageChanged ${newLanguage}`);

  };
  
  const storedLanguage = localStorage.getItem("i18nextLng");

  if (storedLanguage) {
    i18n.changeLanguage(storedLanguage);
  } else {
    i18n.changeLanguage(LANGUAGES.AMHARIC.value);
  }

  // Subscribe to the languageChanged event
  i18n.on('languageChanged', handleLanguageChange);

export default i18n;